/* FACTS · Aufklapp-Karten + Parallax fuer facts-criteria
   ------------------------------------------------------------------
   Regeln aus dem Section-Standard §8:
   - Parallax ueber IntersectionObserver + rAF, Listener wird beim
     Verlassen des Viewports wieder abgemeldet
   - prefers-reduced-motion: kein Parallax, kein Aufklapp-Uebergang
   - Das Aufklappen laeuft ueber CSS (grid-template-rows 0fr -> 1fr),
     JS setzt nur den Zustand. Keine Hoehenmessung, kein Layout-Thrash. */
(function () {
  if (customElements.get('facts-criteria')) return;
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class FactsCriteria extends HTMLElement {
    connectedCallback() {
      this._single = this.getAttribute('data-single') === 'true';
      this._heads = [].slice.call(this.querySelectorAll('[data-fc-head]'));
      this._heads.forEach(function (btn) {
        btn.addEventListener('click', this._toggle.bind(this, btn));
      }.bind(this));

      if (this.hasAttribute('data-parallax') && !REDUCE) this._initParallax();

      var bento = this.querySelector('[data-fc-bento]');
      if (bento) this._initBento(bento);
    }

    /* ---------------- Bento (2026-08-16) --------------------------------
       Klick expandiert eine Karte, die Nachbarn ordnen sich per FLIP neu:
       Positionen vorher/nachher messen, Differenz als Transform invertieren,
       per rAF auf null fahren. Die expandierende Karte skaliert, ihr Inhalt
       wird exakt gegen-skaliert (per-Frame, nicht per CSS-Transition - zwei
       gleichzeitige CSS-Transitions heben sich NICHT exakt auf).
       Scroll-Versatz: EINE Custom Property --fcb-k (-1..1) am Grid, jede
       Karte multipliziert sie im CSS mit ihrem eigenen --fcb-shift. */
    _initBento(grid) {
      this._grid = grid;
      [].slice.call(grid.querySelectorAll('[data-fcb-hit]')).forEach(function (btn) {
        btn.addEventListener('click', this._bentoToggle.bind(this, btn));
      }.bind(this));
      var st = parseFloat(grid.getAttribute('data-stagger'));
      if (st > 0 && !REDUCE) this._initBentoStagger(grid);
    }

    /* Hoehe der offenen Karte messen (2026-08-17, Fix Befund A).
       Vorher wurde .fcb__in.scrollHeight genommen. .fcb__in ist height:100%
       einer gestreckten Rasterzelle - scrollHeight lieferte damit die
       BOXHOEHE der noch geschlossenen Karte (bei 1x2 zwei Zeilen), und die
       Detailhoehe wurde OBENDRAUF addiert. Auf Desktop kamen so 572px
       heraus, wo 272px Inhalt standen.
       Jetzt: die Karte kommt kurz in den Messzustand data-measure - gleiche
       Geometrie wie offen, Detail auf 1fr, Uebergaenge aus - und wird EINMAL
       mit getBoundingClientRect gemessen. Da im Messzustand align-self:start
       gilt, ist das exakt Inhalt plus Innenabstand. Setzen, lesen und
       zuruecknehmen passieren im selben Task, der Browser zeichnet nicht
       dazwischen. */
    _bentoMeasure(card) {
      card.setAttribute('data-notrans', '');
      card.setAttribute('data-measure', '');
      var h = card.getBoundingClientRect().height; /* erzwingt das Layout */
      card.removeAttribute('data-measure');
      /* Zwischenstand 0fr ohne Uebergang festschreiben, sonst startet das
         spaetere Aufklappen nicht bei 0 und die Animation entfaellt. */
      void card.offsetHeight;
      card.removeAttribute('data-notrans');
      return h;
    }

    /* Verankerte Expansion: die Karte waechst AN IHRER POSITION nach
       rechts/unten (am rechten Rand nach links geklappt), statt vom
       dense-Autoflow quer durchs Raster verlegt zu werden. Zeilenzahl
       kommt aus der gemessenen Inhaltshoehe - die Karte ist genau so
       gross wie ihr Text. (Julian 2026-08-16) */
    _bentoPlace(card, grid) {
      var gs = getComputedStyle(grid);
      var cols = gs.gridTemplateColumns.split(' ').length;
      var gap = parseFloat(gs.rowGap) || 0;
      var cgap = parseFloat(gs.columnGap) || gap;
      var rowH = parseFloat(gs.gridAutoRows) || 100;
      var gRect = grid.getBoundingClientRect();
      var cRect = card.getBoundingClientRect();
      var colW = (gRect.width - cgap * (cols - 1)) / cols;
      var col = Math.round((cRect.left - gRect.left) / (colW + cgap)) + 1;
      var row = Math.round((cRect.top - gRect.top) / (rowH + gap)) + 1;
      var spanC = Math.min(2, cols);
      if (col + spanC - 1 > cols) col = cols - spanC + 1; /* rechts: nach links wachsen */
      if (col < 1) col = 1;
      if (row < 1) row = 1;
      /* Zuerst die BREITE festlegen: in zwei Spalten bricht der Text anders
         um, und die Hoehe haengt am Umbruch. Provisorisch eine Zeile - im
         Messzustand streckt align-self:start die Karte ohnehin nicht. */
      card.style.gridColumn = col + ' / span ' + spanC;
      card.style.gridRow = row + ' / span 8';
      var need = this._bentoMeasure(card);
      /* n Zeilen tragen n*rowH + (n-1)*gap. Aufloesen nach n und aufrunden:
         so viele Rasterzeilen wie noetig, keine mehr. Die Karte selbst bleibt
         bei ihrer Inhaltshoehe (align-self:start), die Spanne reserviert nur
         den Platz, damit die Nachbarn nicht darunter laufen. */
      /* rowH ist die feine Rastereinheit, acht davon ergeben eine sichtbare
         Kartenzeile. Deshalb reicht die Reservierung jetzt auf ein Achtel
         genau an den Inhalt heran statt auf eine ganze Zeile. */
      var rows = Math.max(8, Math.ceil((need + gap) / (rowH + gap)));
      card.style.gridRow = row + ' / span ' + rows;
      return need;
    }

    _bentoToggle(btn) {
      var card = btn.closest('[data-fcb]');
      var grid = this._grid;
      var cards = [].slice.call(grid.querySelectorAll('[data-fcb]'));
      var opening = !card.hasAttribute('data-open');
      var self = this;

      var apply = function () {
        cards.forEach(function (c) {
          if (c !== card && c.hasAttribute('data-open')) {
            c.removeAttribute('data-open');
            c.style.gridColumn = '';
            c.style.gridRow = '';
            c.querySelector('[data-fcb-hit]').setAttribute('aria-expanded', 'false');
          }
        });
        if (opening) {
          /* Platzierung VOR dem Oeffnen aus der aktuellen Zelle ableiten.
             EIN Aufruf reicht: _bentoPlace misst im Messzustand bereits die
             Geometrie des offenen Zustands. Der zweite Aufruf von vorher hat
             die Detailhoehe ein zweites Mal aufaddiert. */
          self._bentoPlace(card, grid);
          card.setAttribute('data-open', '');
        } else {
          card.removeAttribute('data-open');
          card.style.gridColumn = '';
          card.style.gridRow = '';
        }
        btn.setAttribute('aria-expanded', opening ? 'true' : 'false');
      };

      if (REDUCE) { apply(); return; }
      if (this._flipRunning) { apply(); return; }

      var first = cards.map(function (c) { return c.getBoundingClientRect(); });
      apply();
      var last = cards.map(function (c) { return c.getBoundingClientRect(); });

      var moves = [];
      cards.forEach(function (c, i) {
        var f = first[i], l = last[i];
        var dx = f.left - l.left, dy = f.top - l.top;
        var sx = l.width > 0 ? f.width / l.width : 1;
        var sy = l.height > 0 ? f.height / l.height : 1;
        if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5 &&
            Math.abs(sx - 1) < 0.005 && Math.abs(sy - 1) < 0.005) return;
        var inner = c.querySelector('.fcb__in');
        c.style.transformOrigin = '0 0';
        if (inner) inner.style.transformOrigin = '0 0';
        moves.push({ el: c, inner: inner, dx: dx, dy: dy, sx: sx, sy: sy });
      });
      if (!moves.length) return;

      var PRE = 'translate3d(0, calc(var(--fcb-k, 0) * var(--fcb-shift, 0px)), 0) ';
      var D = 380, t0 = null, self = this;
      this._flipRunning = true;
      function ease(t) { return 1 - Math.pow(1 - t, 3); }
      function frame(ts) {
        if (t0 === null) t0 = ts;
        var t = Math.min((ts - t0) / D, 1);
        var e = ease(t), f = 1 - e;
        moves.forEach(function (m) {
          var csx = m.sx + (1 - m.sx) * e;
          var csy = m.sy + (1 - m.sy) * e;
          m.el.style.transform = PRE +
            'translate(' + (m.dx * f).toFixed(2) + 'px,' + (m.dy * f).toFixed(2) + 'px) ' +
            'scale(' + csx.toFixed(4) + ',' + csy.toFixed(4) + ')';
          if (m.inner) m.inner.style.transform =
            'scale(' + (1 / csx).toFixed(4) + ',' + (1 / csy).toFixed(4) + ')';
        });
        if (t < 1) { requestAnimationFrame(frame); }
        else {
          moves.forEach(function (m) {
            m.el.style.transform = '';
            m.el.style.transformOrigin = '';
            if (m.inner) { m.inner.style.transform = ''; m.inner.style.transformOrigin = ''; }
          });
          self._flipRunning = false;
        }
      }
      requestAnimationFrame(frame);
    }

    _initBentoStagger(grid) {
      var active = false, ticking = false;
      function update() {
        ticking = false;
        if (!active) return;
        var r = grid.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var p = (vh - r.top) / (vh + r.height);
        if (p < 0) p = 0; else if (p > 1) p = 1;
        grid.style.setProperty('--fcb-k', ((p - 0.5) * 2).toFixed(3));
      }
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }
      this._bentoIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          active = e.isIntersecting;
          if (active) {
            window.addEventListener('scroll', onScroll, { passive: true });
            update();
          } else {
            window.removeEventListener('scroll', onScroll);
          }
        });
      });
      this._bentoIo.observe(grid);
      this._bentoOnScroll = onScroll;
    }

    _toggle(btn) {
      var card = btn.closest('[data-fc-card]');
      var open = card.hasAttribute('data-open');
      if (this._single && !open) {
        this.querySelectorAll('[data-fc-card][data-open]').forEach(function (c) {
          c.removeAttribute('data-open');
          c.querySelector('[data-fc-head]').setAttribute('aria-expanded', 'false');
        });
      }
      if (open) { card.removeAttribute('data-open'); }
      else { card.setAttribute('data-open', ''); }
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    }

    _initParallax() {
      this._media = this.querySelector('[data-fc-media]');
      this._content = this.querySelector('[data-fc-content]');
      if (!this._media && !this._content) return;
      /* Weg in PIXELN, nicht als Anteil der Scrollstrecke. Ein Anteil waechst
         mit der Sectionhoehe - auf Mobil lief das Bild dadurch mehrere hundert
         Pixel und musste entsprechend groesser als sein Rahmen sein, was
         object-fit:cover die Seiten wegschneiden liess. */
      this._mq = window.matchMedia('(min-width: 1020px)');
      this._readTravel();
      this._onMq = this._readTravel.bind(this);
      if (this._mq.addEventListener) this._mq.addEventListener('change', this._onMq);
      this._active = false;
      this._ticking = false;
      this._onScroll = this._onScroll.bind(this);
      this._update = this._update.bind(this);
      this._io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          this._active = e.isIntersecting;
          if (this._active) {
            window.addEventListener('scroll', this._onScroll, { passive: true });
            this._update();
          } else {
            window.removeEventListener('scroll', this._onScroll);
          }
        }.bind(this));
      }.bind(this));
      this._io.observe(this);
    }

    _readTravel() {
      var d = this._mq.matches;
      this._tImg = parseFloat(this.getAttribute(d ? 'data-travel-img-d' : 'data-travel-img-m'));
      this._tCon = parseFloat(this.getAttribute(d ? 'data-travel-content-d' : 'data-travel-content-m'));
      if (isNaN(this._tImg)) this._tImg = 0;
      if (isNaN(this._tCon)) this._tCon = 0;
    }

    _onScroll() {
      if (this._ticking) return;
      this._ticking = true;
      requestAnimationFrame(this._update);
    }

    _update() {
      this._ticking = false;
      if (!this._active) return;
      var r = this.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      /* p laeuft von 0 (Section kommt unten herein) bis 1 (Section oben raus).
         Der Versatz bleibt damit garantiert in [-weg/2, +weg/2]. */
      var p = (vh - r.top) / (vh + r.height);
      if (p < 0) p = 0; else if (p > 1) p = 1;
      var k = p - 0.5;
      if (this._media) {
        this._media.style.transform =
          'translate3d(0,' + (k * this._tImg).toFixed(1) + 'px,0)';
      }
      if (this._content) {
        this._content.style.transform =
          'translate3d(0,' + (k * -this._tCon).toFixed(1) + 'px,0)';
      }
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      if (this._bentoIo) this._bentoIo.disconnect();
      if (this._bentoOnScroll) window.removeEventListener('scroll', this._bentoOnScroll);
      window.removeEventListener('scroll', this._onScroll);
      if (this._mq && this._mq.removeEventListener) this._mq.removeEventListener('change', this._onMq);
    }
  }
  customElements.define('facts-criteria', FactsCriteria);
})();
